const INVOICE_STATUS_LABELS: ReadonlyMap<string, string> = new Map([
    ['submitted', 'Previously invoiced'],
    ['reversed', 'Reversed'],
]);

/** An unlabelled status renders raw until it earns an entry. */
export const invoiceStatusLabel = (status: string): string => INVOICE_STATUS_LABELS.get(status) ?? status;
